/* src/app/admin/client/client-area/create-or-update-client-area.component.scss */
.button-search {
  border-radius: 10px;
  padding: 2px;
  width: 37px;
  height: 37px;
  margin-left: 2px;
  margin-top: 16px;
}
h4 {
  margin: 20px 0;
}
.sub-header {
  font-size: 15px;
  font-weight: 600;
  margin-top: 2px;
}
.action-bar {
  margin-bottom: 5px;
}
.header {
  display: flex;
  align-items: center;
  gap: 16px;
}
/*# sourceMappingURL=create-or-update-client-area.component-2RYE4N3I.css.map */
